export default __webpack_public_path__ + "static/media/a763755d0e3ef326.667ddd93f1f5e450d7656e2880e4d205.svg";